import { Record } from '../../../../../shared';
import { ComponentProps } from 'react';

export const StyledRecord = ({sx = {}, ...props}: ComponentProps<typeof Record>) => (
  <Record {...props} sx={{ '& p.record-title': {width: 80}, '& .record-value-wrapper': {maxWidth: 165}, ...sx }} />
)
